
import apiUrl from '../../../constants'
import axios from 'axios'
import Loader from './../shared/loader'
import CryptoJS from 'crypto-js'
import DatePicker from 'vue2-datepicker'
import Vue from "vue";
import csvHelper from '../reports/importjsontocsv';
import Pagination from './../shared/pagination'
import {
	BasicSelect
} from 'vue-search-select'
import 'vue-search-select/dist/VueSearchSelect.css'
import moment from 'moment'

export default {
	name: 'slabreach',
	components: {
		Loader,
		DatePicker,
		Pagination,
	},

	data: function () {
		return {
			csvCheck : 0,
			dataFilter2 :'',
			filterData : '',
			csvFieldsForXls: {},
			listReportDataforxls : [],
			slabreachreasonlistCsv : [],
			show : false,
			downloadButtonFlag: false,
			download : true,
			addmodalbreachby :'',
			addmodalsourceid: '',
			addmodaldrcreation : '',
			addmodalsladatetime : '',
			addmodalwarehouseid : '',
			addmodalclientid : '',
			addmodalcreateddate : '',
			addmodalStatus : '',
			addmodalpoid : '',
			addmodalawbno : '',
			addmodalfromdate : '',
			addmodeltodate : '',
			addmodalbreachreason : '',
			addmodalcomments : '',
			addmodalawbno : '',
			addmodalordercreation : '',
			addmodalwhinscan : '',
			isLoading: false,
			addcategorymodal: false,
			categoryaction: '',
			Status:'',
			type : '',
			token : '',
			totalPage: 0,
			totalRows: 0,
			currentPage: 1,
			pageLimit: 10,
			globalObject : '',
			client : '',
			warehouse : '',
			warehouseid : '',
			formattedDate: '',
			clientid : '',
			client : '',
			user_type : '',
			showlist : true,
			limitExeed:false,
			recordLimit:0,
			fromDate: "",
			toDate: "",
			drid:'',
			poid : '',
			orderid:'',
			awbno:'',
			breachreason : '',
			returntype:'',
			activeClass: 'btn-success',
			warningClass: 'btn-warning',
			drcreation : false,
			drclose : false,
			multiselectflag :false,
			resultCount : 0,
			slabreachreasonlist : [],
			breachreasonslist : '',
			addbreachreasonmodal : false,
			closebreachreasonmodal : false,
			currentDate : '',
			isLoadingforxls : false,
		}
	},
	filters: {

		moment: function (date) {
			if (date != null)
				return moment(date).format('DD-MM-YYYY');
		},
		momentDateTime: function (date) {
			if (date != null)
				return moment(date).format('DD/MM/YYYY HH:mm:ss');
		}
	},
	mounted() {
		this.calldateFunction()
		this.breachreasonlist()
		this.reportname = this.$t('common.breachreport')
		this.reportname = this.reportname + moment().format('DD-MM-YY_HH-mm-ss') + '.xls';
		var userdetailEncrypt = window.localStorage.getItem('userdetail')
		var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key')
		var plaintext = bytes.toString(CryptoJS.enc.Utf8)
		var userdetail = JSON.parse(plaintext)
		var userToken = window.localStorage.getItem('userToken')
		this.token = userToken.replace(/"/g, '')
		var today = new Date();
		this.formattedDate = moment(today).format('DD/MM/YYYY HH:mm:ss')
		// this.globalObject.userEmail = userdetail.email
		this.client = window.localStorage.getItem('selectedClient')
		this.warehouse = window.localStorage.getItem('selectedWarehouse')
		this.warehouseid= this.warehouse
		this.clientid =this.client
		this.checkclient()
		this.checkwarehouse()
		this.user_type = userdetail.utype
		this.resultCount = 0
		this.Status = 'inbound'

		switch (this.user_type) {
			case 'system_user':
				this.checkclient()
				this.checkwarehouse()
				break

			case 'client_user':
				this.checkwarehouse()
				break

			case 'warehouse_user':
				this.checkclient()
				break

			default:
				this.$alert("Unauthorised user, Please contact your system admin")
				break
		}
		this.getRecordLimit();
		this.$root.$on('localStorageChanged', (newValue) => {
			// Update your local data
			this.warehouse = newValue;
		  });
	},
	methods:{
		formatDate(dateString) {
			if (dateString == null)
				return dateString
			const date = new Date(dateString);

			// Extract date components
			const day = String(date.getDate()).padStart(2, '0');
			const month = String(date.getMonth() + 1).padStart(2, '0');
			const year = date.getFullYear();

			// Extract time components
			const hours = String(date.getHours()).padStart(2, '0');
			const minutes = String(date.getMinutes()).padStart(2, '0');
			const seconds = String(date.getSeconds()).padStart(2, '0');

			// Format the date in "dd-mm-yyyy" format
			const formattedDate = `${day}-${month}-${year}`;

			// Combine with time
			const formattedDateTime = `${formattedDate} ${hours}:${minutes}:${seconds}`;

			return formattedDateTime;
		},
		getRecordLimit() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.input = ({

			})
			axios({
				method: 'POST',
				'url': apiUrl.api_url + 'getRecordLimit',
				'data': this.input,
				headers: {
					'Authorization': 'Bearer ' + myStr
				}
			})
				.then(result => {
					if (result.data) {
						this.recordLimit = result.data.data;


					}
				}, error => {
					console.error(error)
				})
		},
		startDownload() {
			this.isLoadingforxls = true;
		},
		finishDownload() {
			this.isLoadingforxls = false;
		},
		dateFormat1(date) {
			if (!date) return '';
			return moment(date).format('YYYY-MM-DD') + " 00:00:00";
		},
		dateFormat2(date) {
			if (!date) return '';
			return moment(date).format('YYYY-MM-DD') + " 23:59:59";
		},
		time() {
			var self = this
			this.datenow = moment().format()
			setInterval(self.time, 1000)
		},
		calldateFunction: function () {
			this.currentDate = new Date().toJSON().slice(0, 10).replace(/-/g, '/');
			this.toDate = this.currentDate;
			var dt = new Date(this.currentDate);
			dt.setDate(dt.getDate() - 7);
			this.fromDate = dt;
		},
		checkclient(){
			if (localStorage.getItem("selectedClient") == 'undefined' || localStorage.getItem("selectedClient") == '')
			{
				this.$alertify.error(this.$t('common.clientError'))
				this.isLoading = false
				return false
			}
		},
		checkwarehouse(){
			if (localStorage.getItem("selectedWarehouse") == 'undefined' || localStorage.getItem("selectedWarehouse") == '')
			{
				this.$alertify.error(this.$t('common.warehouseError'))
				this.isLoading = false
				return false
			}
		},
		loadBreachreasonapage(status) {
			console.log(this.Status)
			this.totalRows = 0
			this.fromDate=""
			this.toDate= ""
			this.drid=''
			this.poid = ''
			this.orderid = ''
			this.breachreason =''
			this.awbno = ''
			this.returntype=''
			this.Status = status
			if (this.Status == 'inbound')
			{
				this.type = 'drcreation'
			}
			if (this.Status == 'outbound')
			{
				this.type = 'ordercreation'
			}
			if (this.Status == 'returns')
			{
				this.type = 'whinscandate'
			}
			this.resetaddmodalform()
			this.slabreachreasonlist =[]
			this.calldateFunction()
		},
		datetimechange(obj)
		{
			if (obj == 1)
			{
				if (this.Status == 'inbound')
				{
					this.type = 'drcreation'
				}
				if (this.Status == 'outbound')
				{
					this.type = 'ordercreation'
				}
				if (this.status == 'returns')
				{
					this.type = 'whinscandate'
				}
			}
			if (obj == 2)
			{
			 	this.type = 'sladatetime'
			}
		},
		formatBreachBy(breachBy) {
			var totalHours;
			if ('days' in breachBy) {
				const { days , hours, minutes, seconds, milliseconds } = breachBy;
				if (breachBy.hours == null)
				{
					totalHours = days * 24;
				}
				else
				{
					totalHours = days * 24 + hours;

				}
				return `${totalHours}:${minutes < 10 ? '0' : ''}${minutes}`;
			} else {

				const { hours, minutes, seconds, milliseconds } = breachBy;
				totalHours = hours
				return `${totalHours}:${minutes < 10 ? '0' : ''}${minutes}`;
			}


    },
	convertBreachDuration(breach) {
		const totalMilliseconds = breach.days * 24 * 60 * 60 * 1000 + breach.hours * 60 * 60 * 1000 + breach.minutes * 60 * 1000 + breach.seconds * 1000 + breach.milliseconds;
		const totalHours = Math.floor(totalMilliseconds / (1000 * 60 * 60));
		const totalMinutes = Math.floor((totalMilliseconds % (1000 * 60 * 60)) / (1000 * 60));
		return `${totalHours}:${totalMinutes}`;
	},

		breachreasonlist() {
			var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');
			axios({
				method: 'POST',
				'url': apiUrl.api_url + 'getslabreachreasons',
				'data': {
				},
				headers: {
					'Authorization': 'Bearer ' + myStr,
				}
			})
				.then(result => {
					this.breachreasonslist = result.data.data;
				}, error => {
					console.error(error);
				});
		},
		slabreachsearch(csvCheck){
			this.csvCheck = csvCheck
			console.log(this.csvCheck)
			this.isLoading = true;
			this.show = false;
			this.download = true;
			this.totalPage=0;
			this.limitExeed = false;
			this.downloadButtonFlag = true;

			var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');
			this.checkclient()
			this.checkwarehouse()
			if (this.Status == 'returns')
			{
				if (this.returntype == '')
				{
					this.$alertify.error("Select a required a Returns Type");
				}
			}
			if (((this.fromDate == '' || this.fromDate == null) && (this.toDate == '' || this.toDate == null)) || (this.fromDate == '' || this.fromDate == null) || (this.toDate == '' || this.toDate == null) ) {
				this.$alertify.error(this.$t('common.dateError'));
				this.pageNo = this.totalPage = 0;
				this.slabreachreasonlist = [];
				this.totalRows = 0;
				this.isLoading = false
				return false;
			}

			var months;
			var from = new Date(this.fromDate);
			var To = new Date(this.toDate);
			months = To.getMonth() - from.getMonth() + (12 * (To.getFullYear() - from.getFullYear()))
			if (months > 3) {
				this.$alertify.error(this.$t('common.dateError'));
				this.pageNo = this.totalPage = 0;
				this.totalRows = 0;
				// this.slabreachreasonlist = []
				this.isLoading = false
				return false;
			}
			var source = '';
			if (this.Status == 'inbound'){
				source = this.drid
			}
			if (this.Status == 'outbound')
			{
				source = this.orderid
			}
			if (this.Status == 'returns')
			{
				source = this.orderid
			}
			// console.log(source+"fsfwe"+this.Status)
			this.input = ({
				offset: (this.currentPage - 1) * 10,
				limit: this.pageLimit,
				poid: this.poid.trim(),
				fromDate: this.dateFormat1(this.fromDate),
				toDate: this.dateFormat2(this.toDate),
				warehouseid: window.localStorage.getItem("selectedWarehouse"),
				clientid: localStorage.getItem("selectedClient"),
				breachreason: this.breachreason,
				Status: this.Status,
				dateoption : this.type,
				returnstype : this.returntype,
				awb : this.awbno,
				sourceid : source,
				csvData: this.csvCheck,
			});
			console.log()

			var dataFilter = {}
			Object.entries(this.input).forEach(([k, v]) => {
				let skipkeys = ['offset', 'limit', 'csvData'];
				if (v != null && v != '' && skipkeys.indexOf(k) == -1) {
					dataFilter[k] = v;
				}
			})
			this.filterData = this.input

			axios({
				method: 'POST',
				'url': apiUrl.api_url + 'getslabreachlist',
				'data':
					this.input,
					headers: {
					'Authorization': 'Bearer ' + myStr,
					}
			})
				.then(result => {
					this.isLoading = false
					if (result.data.count < 1)
					{
						this.totalRows = 0;
						this.slabreachreasonlist = [];
						this.resultCount=0;
						return false
					}
					this.resultCount = result.data.count;
					this.totalRows = this.resultCount
					this.slabreachreasonlist = result.data.data.breachdetails;
					this.resultCount = result.data.count;
					this.totalRows = result.data.totalRows;
					if (csvCheck == 1) {
						if (this.totalRows < 10) {
							this.totalPage = 1
						} else {
							this.totalPage = Math.ceil(this.totalRows / 10);
							console.log('this.page',this.totalPage);
						}
						if (this.totalRows > 0) {
							this.show = true;
							this.download = false;
							if (this.Status == 'inbound')
							{
							this.csvFields = {
								'pono': this.$t('removeHold.poId'),
								'invreferenceid': this.$t('removeHold.drId'),
								'createddate': this.$t('editedjson.drcreation'),
								'closeddate': this.$t('sla.drclose'),
								'sladatetime': this.$t('editedjson.sladatetime'),
								'createdby':this.$t('common.createdBy'),
								'breachby': this.$t('sla.breachby'),
								'breachreason':  this.$t('sla.breachreason'),
								'breachcomment': this.$t('common.breachcomment'),
							};
						}
						if (this.Status == 'outbound')
						{
							this.csvFields = {
								'poid': this.$t('removeHold.poId'),
								'linecreateddate': this.$t('pickingReport.table.columns.orderCreatedDate'),
								'orderdispatchdatetime': this.$t('sla.orderdispatch'),
								'createdby': this.$t('common.createdBy'),
								'sladatetime': this.$t('editedjson.sladatetime'),
								'warehouseid': this.$t('common.warehouseID'),
								'clientid': this.$t('client.clientId'),
								'breachby': this.$t('sla.breachby'),
								'breachreason':  this.$t('sla.breachreason'),
								'breachcomment': this.$t('common.breachcomment')
							};
						}
						if (this.Status == 'returns')
						{
							this.csvFields = {
								'returnstype': this.$t('common.breachcomment'),
								'awbno': this.$t('common.awbNo'),
								'orderid': this.$t('common.orderID'),
								'inscandatetime':this.$t('common.whinscandate'),
								'sladatetime': this.$t('editedjson.sladatetime'),
								'rackindatetime': this.$t('editedjson.rackinDate'),
								'putawaydate': this.$t('common.putawaydatetime'),
								'breachby': this.$t('sla.breachby'),
								'breachreason':  this.$t('sla.breachreason'),
								'breachcomment': this.$t('common.breachcomment')
							};
						}
							// console.log(this.csvFields)
							var dateFilter = ['createddate','closeddate','sladatetime']
							var skipFilter = ['count'];
							// var dataFilter = []
							this.slabreachreasonlistCsv = result.data.data.breachdetails
							csvHelper.data.jsonToCSV(this.$t('common.breachreport'), this.slabreachreasonlistCsv, this.csvFields, dateFilter, skipFilter, dataFilter);

						} else {
							if (result.data.status == true) {
								this.$alertify.success(this.$t('common.reportSizeError'));
							} else {
								this.$alertify.error(result.data.msg.message);
							}
						}
					}else{
						if (result.data.errorCode == -1) {
							this.totalRows = 0;
						}else{
							this.resultCount = result.data.count;
							this.totalRows = result.data.totalRows;
							if (Number(this.totalRows) > Number(this.recordLimit)) {
								this.limitExeed = true
							}
							if (this.totalRows < 10) {
								this.totalPage = 1
							} else {
								this.totalPage = Math.ceil(this.totalRows / 10);
								console.log('this.page',this.totalPage);
							}
						}
					}
					this.isLoading = false;

				},error => {
					console.error(error);
		});
		},

		slabreachsearchxls(csvCheck = 0){
			this.isLoading = true;
			var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');
			this.checkclient()
			this.checkwarehouse()
			if (this.Status == 'returns')
			{
				if (this.returntype == '')
				{
					this.$alertify.error("Select a required a Returns Type");
				}
			}
			if ((this.fromDate == '' || this.fromDate == null) && (this.toDate == '' || this.toDate == null)) {
				this.$alertify.error(this.$t('common.dateError'));
				this.pageNo = this.totalPage = 0;
				this.slabreachreasonlist = [];
				this.totalRows = 0;
				this.isLoading = false
				return false;
			}
			this.dataFilter2 = []
			var months;
			var from = new Date(this.fromDate);
			var To = new Date(this.toDate);
			months = To.getMonth() - from.getMonth() + (12 * (To.getFullYear() - from.getFullYear()))
			if (months > 3) {
				this.$alertify.error(this.$t('common.dateError'));
				this.pageNo = this.totalPage = 0;
				this.totalRows = 0;
				this.slabreachreasonlist = []
				this.isLoading = false
				return false;
			}
			var source = '';
			if (this.Status == 'inbound'){
				source = this.drid
			}
			if (this.Status == 'outbound')
			{
				source = this.orderid
			}
			if (this.Status == 'returns')
			{
				source = this.orderid
			}
			// console.log(source+"fsfwe"+this.Status)
			this.input = ({
				offset: (this.currentPage - 1) * 10,
				limit: this.pageLimit,
				poid: this.poid.trim(),
				fromDate: this.dateFormat1(this.fromDate),
				toDate: this.dateFormat2(this.toDate),
				warehouseid: window.localStorage.getItem("selectedWarehouse"),
				clientid: localStorage.getItem("selectedClient"),
				breachreason: this.breachreason,
				Status: this.Status,
				dateoption : this.type,
				returnstype : this.returntype,
				awb : this.awbno,
				sourceid : source,
			});


			Object.entries(this.input).forEach(([k, v]) => {
				let skipkeys = ['offset', 'limit', 'csvData'];
				if (v != null && v != '' && skipkeys.indexOf(k) == -1) {
					this.dataFilter2[k] = v;
				}
			})
			this.filterData = this.input

			axios({
				method: 'POST',
				'url': apiUrl.api_url + 'getslabreachlist',
				'data':
					this.input,
					headers: {
					'Authorization': 'Bearer ' + myStr,
					}
			})
				.then(result => {
					this.isLoading = false
					// this.totalRows = this.resultCount
					this.slabreachreasonlist = result.data.data.breachdetails;
					console.log(JSON.stringify(this.slabreachreasonlist))
					if (csvCheck == 3) {
						if (this.totalRows > 0) {
							this.listReportDataforxls = [];
							if (this.Status == 'inbound')
							{
								this.csvFieldsForXls = {}
								this.csvFieldsForXls[this.$t('removeHold.poId')]='pono',
								this.csvFieldsForXls[this.$t('removeHold.drId')]='invreferenceid',
								this.csvFieldsForXls[this.$t('editedjson.drcreation')]='createddate',
								this.csvFieldsForXls[this.$t('sla.drclose')]='closeddate',
								this.csvFieldsForXls[this.$t('editedjson.sladatetime')]='sladatetime',
								this.csvFieldsForXls[this.$t('common.createdBy')]='createdby',
								this.csvFieldsForXls[this.$t('sla.breachby')]='breachby',
								this.csvFieldsForXls[this.$t('sla.breachreason')]='breachreason',
								this.csvFieldsForXls[this.$t('common.breachcomment')]='breachcomment'
							}
							if (this.Status == 'outbound')
							{
								this.csvFieldsForXls = {}
								this.csvFieldsForXls[this.$t('removeHold.poId')]='poid',
								this.csvFieldsForXls[this.$t('pickingReport.table.columns.orderCreatedDate')]='linecreateddate',
								this.csvFieldsForXls[this.$t('sla.orderdispatch')]='orderdispatchdatetime',
								this.csvFieldsForXls[this.$t('common.createdBy')]='createdby',
								this.csvFieldsForXls[this.$t('editedjson.sladatetime')]='sladatetime',
								this.csvFieldsForXls[this.$t('common.warehouseID')]='warehouseid',
								this.csvFieldsForXls[this.$t('client.clientId')]='clientid',
								this.csvFieldsForXls[this.$t('sla.breachby')]='breachby',
								this.csvFieldsForXls[this.$t('sla.breachreason')]='breachreason',
								this.csvFieldsForXls[this.$t('common.breachcomment')]='breachcomment'
							}
						if (this.Status == 'returns')
						{
							this.csvFieldsForXls = {}
							this.csvFieldsForXls[this.$t('common.breachcomment')]='returnstype',
							this.csvFieldsForXls[this.$t('common.awbNo')]='awbno',
							this.csvFieldsForXls[this.$t('common.orderID')]='orderid',
							this.csvFieldsForXls[this.$t('common.whinscandate')]='inscandatetime',
							this.csvFieldsForXls[this.$t('editedjson.sladatetime')]='sladatetime',
							this.csvFieldsForXls[this.$t('editedjson.rackinDate')]='rackindatetime',
							this.csvFieldsForXls[this.$t('common.putawaydatetime')]='putawaydate',
							this.csvFieldsForXls[this.$t('sla.breachby')]='breachby',
							this.csvFieldsForXls[this.$t('sla.breachreason')]='breachreason',
							this.csvFieldsForXls[this.$t('common.breachcomment')]='breachcomment'
						}
							// console.log(this.csvFields)
							this.listReportDataforxls = result.data.data.breachdetails;
						} else {
							if (result.data.status == true) {
								this.$alertify.success(this.$t('common.reportSizeError'));
							} else {
								this.$alertify.error(result.data.msg.message);
							}
						}
					}
				});
		},
		onPageChange(page) {
			this.currentPage = page;
			window.localStorage.setItem('currentPage', this.currentPage)
			this.slabreachsearch(0)
		  },
		viewbreachreasons(data)
		{
			this.addbreachreasonmodal = true
			this.categoryaction = 'view'
			this.addmodalStatus = this.Status
			this.addmodalclientid = localStorage.getItem("selectedClient")
			this.addmodalwarehouseid = localStorage.getItem("selectedWarehouse")
			this.addmodalsladatetime = data.sladatetime
			this.addmodalcomments = data.breachcomment
			this.addmodalbreachreason = data.breachreason
			this.addmodalbreachby = data.breachby
			if (this.Status == 'inbound'){
			this.addmodalpoid = data.pono
			this.addmodalsourceid = data.invreferenceid
			this.addmodaldrcreation = data.createddate
			}
			if (this.Status == 'outbound')
			{
			this.addmodalsourceid = data.poid
			this.addmodalordercreation = data.linecreateddate
			}
			if (this.Status == 'returns')
			{
			this.addmodalsourceid = data.orderid
			this.addmodalawbno = data.awbno
			this.addmodalwhinscan = data.inscandatetime
			}
		},
		updatebreachreasons(data)
		{
			this.addbreachreasonmodal = true
			this.categoryaction = 'add'
			this.addmodalStatus = this.Status
			this.addmodalclientid = localStorage.getItem("selectedClient")
			this.addmodalwarehouseid = localStorage.getItem("selectedWarehouse")
			this.addmodalcomments = data.breachcomment
			this.addmodalbreachreason = data.breachreason
			this.addmodalbreachby = data.breachby
			if (this.Status == 'inbound'){
			this.addmodalpoid = data.pono
			this.addmodalsourceid = data.invreferenceid
			this.addmodaldrcreation = data.createddate
			this.addmodalsladatetime = data.sladatetime
			}
			if (this.Status == 'outbound')
			{
			this.addmodalsourceid = data.poid
			this.addmodalordercreation = data.linecreateddate
			this.addmodalsladatetime = data.sladatetime
			}
			if (this.Status == 'returns')
			{
			this.addmodalsourceid = data.orderid
			this.addmodalawbno = data.awbno
			this.addmodalwhinscan = data.inscandatetime
			this.addmodalsladatetime = data.sladatetime
			}
		},

		editbreachreason()
		{
			this.checkwarehouse()
			this.checkclient()

			var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');
			if (this.addmodalcomments == null)
			{
				this.addmodalcomments = ''
			}
			if (this.addmodalbreachreason == null)
			{
				this.$alertify.error("Breach Reasons required")
				this.addmodalbreachreason = ''
				return false
			}
			this.input = ({
				sourcetype: this.Status,
				sourceid : this.addmodalsourceid,
				warehouseid : localStorage.getItem("selectedWarehouse"),
				clientid : localStorage.getItem("selectedClient"),
				breachby : this.addmodalbreachby,
				breachreason : this.addmodalbreachreason,
				breachcomments : this.addmodalcomments,
			});

			axios({
				method: 'POST',
				'url': apiUrl.api_url + 'updatebreachdetails',
				'data':
					this.input,
					headers: {
					'Authorization': 'Bearer ' + myStr,
					}
			})
				.then(result => {
					// console.log(result.data.msg)
					if (result.data.msg.length > 0)
					{
						const msg = result.data.msg
						this.$alertify.success("Data Updated Successsfully")
						console.log("updated")
						this.addbreachreasonmodal = false
						this.slabreachsearch()
					}
					else{
					this.$alertify.error("Data not updated");
					this.addbreachreasonmodal = false
					this.resetaddmodalform()
					}

				}, error => {
					this.$alertify.error("Data not updated");
					this.addbreachreasonmodal = false
					console.error(error);
					this.resetaddmodalform()
				});

		},
		addbreachreason()
		{
			this.checkwarehouse()
			this.checkclient()

			var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');
			if (this.addmodalbreachreason == null)
			{
				this.$alertify.error("Breach Reasons Required")
				this.addmodalbreachreason = ''
				return false
			}
			if (this.addmodalcomments == null)
			{
				this.addmodalcomments = ''
			}
			this.input = ({
				sourcetype: this.Status,
				sourceid : this.addmodalsourceid,
				warehouseid : localStorage.getItem("selectedWarehouse"),
				clientid : localStorage.getItem("selectedClient"),
				breachby : this.addmodalbreachby,
				breachreason : this.addmodalbreachreason,
				breachcomments : this.addmodalcomments,
			});

			axios({
				method: 'POST',
				'url': apiUrl.api_url + 'updatebreachdetails',
				'data':
					this.input,
					headers: {
					'Authorization': 'Bearer ' + myStr,
					}
			})
				.then(result => {
					// console.log(result.data.msg)
					if (result.data.msg.length > 0)
					{
						const msg = result.data.msg
						this.$alertify.success("Data Added Successsfully")
						// console.log("updated")
						this.addbreachreasonmodal = false
						this.slabreachsearch()
					}
					else{
					this.$alertify.error("Data not added");
					this.addbreachreasonmodal = false
					this.resetaddmodalform()
					}

				}, error => {
					this.$alertify.error("Data not added");
					this.addbreachreasonmodal = false
					console.error(error);
					this.resetaddmodalform()
				});

		},
		closemodal()
		{
			this.addbreachreasonmodal = false
			this.resetaddmodalform()
		},
		resetform() {
			this.slabreachreasonlist = []
			this.fromDate = ""
			this.toDate = ""
			this.awbno = ''
			this.totalRows= 0
			this.resultCount =0
			if (this.Status == 'inbound')
			{
				document.getElementById("drid").value = "";
				document.getElementById("poid").value = "";
			}
			if (this.Status == 'outbound')
			{
				document.getElementById("awbno").value = "";
				document.getElementById("orderid").value = "";
			}
			if (this.Status == 'returns')
			{
				document.getElementById("orderid").value = "";
			}
			this.orderid  = ''
			this.drid = ''
			this.poid = ''
			this.awbno = ''
			this.breachreason = ""
			this.returntype =""
			this.resetaddmodalform()
		},
		Choosetype() {
			this.show = true;
			this.download = false;
			if (!this.limitExeed) {
				this.slabreachsearchxls(3)
			}
		},
		resetaddmodalform()
		{
			this.addbreachreasonmodal = false
			this.categoryaction = ''
			this.addmodalStatus = ''
			this.addmodalcomments = ''
			this.addmodalbreachreason = ''
			this.addmodalbreachby = ''
			if (this.Status == 'inbound'){
			this.addmodalpoid = ''
			this.addmodalsourceid = ''
			this.addmodaldrcreation = ''
			this.addmodalsladatetime = ''
			}
			if (this.Status == 'outbound')
			{
			this.addmodalsourceid = ''
			this.addmodalordercreation = ''
			this.addmodalsladatetime = ''
			}
			if (this.Status == 'returns')
			{
			this.addmodalsladatetime = ''
			this.addmodalsourceid = ''
			this.addmodalawbno = ''
			this.addmodalwhinscan = ''
			}
		}
	},
}


// WEBPACK FOOTER //
// ./src/views/components/slabreach/slabreach.component.js